import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Loader2, Mail, AlertTriangle } from 'lucide-react';

const API = `${window.location.origin}/api`;

export default function InvitePreview({ token, onResolved }) {
  const [state, setState] = useState({ loading: true, data: null, error: null });

  useEffect(() => {
    let mounted = true;
    if (!token) {
      setState({ loading: false, data: null, error: null });
      return;
    }
    (async () => {
      try {
        const res = await axios.get(`${API}/invites/${token}`);
        if (!mounted) return;
        const data = res.data;
        setState({ loading: false, data, error: null });
        onResolved && onResolved(data);
      } catch (err) {
        if (!mounted) return;
        const detail = err.response?.data?.detail;
        const msg = typeof detail === 'string' ? detail : 'Davet bulunamadı veya süresi dolmuş';
        setState({ loading: false, data: null, error: msg });
        onResolved && onResolved(null);
      }
    })();
    return () => { mounted = false; };
  }, [token, onResolved]);

  if (!token) return null;

  if (state.loading) {
    return (
      <div style={{
        background: 'var(--surface-muted)',
        border: '1px solid var(--border)',
        borderRadius: 8,
        padding: 12,
        marginBottom: 18,
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        fontSize: 12.5,
        color: 'var(--text-muted)',
      }}>
        <Loader2 size={14} className="animate-spin" />
        Davet bilgileri yükleniyor...
      </div>
    );
  }

  if (state.error || !state.data) {
    return (
      <div style={{
        background: 'var(--danger-weak, rgba(239,68,68,0.08))',
        border: '1px solid var(--danger, #ef4444)',
        borderRadius: 8,
        padding: 12,
        marginBottom: 18,
        display: 'flex',
        alignItems: 'flex-start',
        gap: 10,
        fontSize: 12.5,
        color: 'var(--danger, #ef4444)',
      }}>
        <AlertTriangle size={14} style={{ marginTop: 2, flexShrink: 0 }} />
        <span>{state.error || 'Davet geçersiz'}</span>
      </div>
    );
  }

  const { invite, workspace, inviter } = state.data;
  const inactive = invite?.status && invite.status !== 'pending';

  if (inactive) {
    return (
      <div style={{
        background: 'var(--surface-muted)',
        border: '1px solid var(--border)',
        borderRadius: 8,
        padding: 12,
        marginBottom: 18,
        display: 'flex',
        alignItems: 'flex-start',
        gap: 10,
        fontSize: 12.5,
        color: 'var(--text-muted)',
      }}>
        <AlertTriangle size={14} style={{ marginTop: 2, flexShrink: 0 }} />
        <span>Bu davet artık geçerli değil (durum: {invite.status}).</span>
      </div>
    );
  }

  return (
    <div style={{
      background: 'linear-gradient(135deg, rgba(126,182,240,.08) 0%, rgba(126,182,240,.02) 100%)',
      border: '1px solid var(--accent)',
      borderRadius: 10,
      padding: 14,
      marginBottom: 20,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
        <Mail size={14} style={{ color: 'var(--accent)' }} />
        <div style={{ fontSize: 11, fontWeight: 600, letterSpacing: '.05em', textTransform: 'uppercase', color: 'var(--accent)' }}>
          Workspace Daveti
        </div>
      </div>
      <div style={{ fontSize: 13, color: 'var(--text)', lineHeight: 1.55 }}>
        <strong>{inviter?.name || 'Bir yönetici'}</strong> sizi{' '}
        <strong>{workspace?.name || 'OnxFlow Workspace'}</strong>'ine{' '}
        <strong>{invite.role}</strong> rolüyle davet etti.
      </div>
      <div style={{ marginTop: 6, fontSize: 11.5, color: 'var(--text-muted)' }}>
        Davet edilen e-posta: <span style={{ fontFamily: 'JetBrains Mono, monospace' }}>{invite.email}</span>
      </div>
    </div>
  );
}
